<template>
    <div class="license-pane">
        <el-row>
            <el-col :span="20">
                <el-row class="info-item">
                    <el-col :span="3" class="label">
                        营业执照代码：
                    </el-col>
                    <el-col :span="18" class="value">
                        {{ code || '--' }}
                    </el-col>
                </el-row>
                <el-row class="info-item" style="padding-bottom: 0;">
                    <el-col :span="3" class="label">
                        营业执照：
                    </el-col>
                    <el-col :span="18" class="value">
                        <!-- !! 注意：若有参数传递，使用回调-->
                        <div class="license-viewer-pane" v-viewer="{ shown: () => handleViewerShown('license') }">
                            <div
                                class="preview-img"
                                v-for="src in license"
                                :style="{ background: 'url(' + src + ') no-repeat center center / 100%' }"
                                :key="src"
                            >
                                <!-- pdf -->
                                <!-- todo: 封装viewer, 兼容pdf -->
                                <div class="pdf-viewer" v-if="isPdf(src)">
                                    <pdf-viewer :pdf="src"></pdf-viewer>
                                </div>

                                <!-- 图片做背景图处理： 预览按钮已隐式处理图片，防止viewer组件重复加载相同img  -->
                                <!-- <img class="view-img" :src="src" /> -->
                                <span class="view-btn iconfont el-icon-zoom-in">
                                    <img class="view-mask-img" :src="src" />
                                </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="info-item">
                    <el-col :span="3" class="label">
                        资质证明：
                    </el-col>
                    <el-col :span="18" class="value">
                        <div
                            class="qualification-viewer-pane"
                            v-viewer="{ shown: () => handleViewerShown('qualification') }"
                        >
                            <div
                                class="preview-img"
                                v-for="src in qualification"
                                :style="{ background: 'url(' + src + ') no-repeat center center / 100%' }"
                                :key="src"
                            >
                                <!-- pdf -->
                                <div class="pdf-viewer" data-pdf="pdf" v-if="isPdf(src)">
                                    <pdf-viewer :pdf="src"></pdf-viewer>
                                </div>

                                <span class="view-btn iconfont el-icon-zoom-in">
                                    <img class="view-mask-img" :src="src" />
                                </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import $util from '@/common/js/util';
import PdfViewer from '@/components/PdfViewer';

export default {
    name: 'DetailLicensePane',
    components: { PdfViewer },
    props: {
        license: {
            type: Array,
            default: () => []
        },
        qualification: {
            type: Array,
            default: () => []
        },
        code: {
            type: String
        }
    },
    methods: {
        // isPdf
        isPdf (url = '') {
            return /.(pdf)$/.test(url);
        },

        // 兼容pdf预览
        handleViewerShown (type) {
            const viewer = this.$el.querySelector(`.${type}-viewer-pane`).$viewer;
            const img = this[type][viewer.index] || '';
            const pdf = this.isPdf(img);

            if (pdf) {
                $util.openUrl(img, { newWin: true });
                viewer.hide();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.license-pane {
    .info-item {
        padding-bottom: 24px;
        .label {
            display: inline-block;
            width: 130px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(144, 147, 153, 1);
        }
        .value {
            font-size: 14px;
            font-weight: 500;
            color: rgba(48, 49, 51, 1);

            .preview-img {
                display: inline-block;
                margin: 0 24px 24px 0;
                position: relative;
                width: 200px;
                height: 200px;
                overflow: hidden;
                border: 1px solid #ddd;

                &:hover {
                    .view-btn,
                    &::before {
                        display: block;
                    }
                }

                &::before {
                    display: none;
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.2);
                }

                .view-btn {
                    display: none;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 3;
                    color: #fff;
                    font-size: 30px;

                    .view-mask-img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 2;
                        width: 100%;
                        opacity: 0;
                    }
                }

                .view-img {
                    position: absolute;
                    top: 0;
                    width: 100%;
                    left: 0;
                }
            }
        }
    }
}
</style>
